export class uploadModel {
  
    constructor(
      public filename: string,  
      public content_type: string,
      public mail: string,
      public passw: string,
      public order_id: string  
    ) {  }
  
  }


// WEBPACK FOOTER //
// ./src/app/create-workspace/http-post-request-object-classes/uploadModel.ts